module.exports = __webpack_public_path__ + "img/PRNT_05_mono_AE_00002.28ace3bf.png";